import { FC } from 'react'
import Image from 'components/Image'
import Typography from 'components/Typography'
import Button from 'components/Button'
import styles from './EmptyProfile.module.scss'
import * as events from 'pages/recomendacoes/events'

type TProps = {
  openQEVModal: () => void
}

const EmptyProfile: FC<TProps> = ({ openQEVModal }) => {
  return (
    <div className={styles.ecRecommendationsPageEmptyProfile}>
      <div className={styles.ecRecommendationsPageEmptyProfileWrapper}>
        <Image
          src="/img/recommendations/properties-2.webp"
          width={956}
          height={720}
          alt="abc"
        />
        <Typography
          as="h1"
          variant="TitleSmall"
          bold
          className={styles.ecRecommendationsPageEmptyProfileTitle}
        >
          Recomendações para você
        </Typography>

        <Typography className={styles.ecRecommendationsPageEmptyProfileText}>
          Conte o que você procura e veja recomendação de imóveis que te
          atendem.
        </Typography>
        <Button
          theme="pink"
          size="big"
          className={styles.ecRecommendationsPageEmptyProfileButton}
          onClick={() => {
            openQEVModal()
            events.recommendationsQEVButtonClickEvent()
          }}
        >
          Ver recomendações
        </Button>
      </div>
    </div>
  )
}

export default EmptyProfile
